/* eslint-disable jsx-a11y/click-events-have-key-events */
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import React, { useContext, useState } from 'react'

import { ModalNotAuth } from '../../../../Components'
import colorContext from '../../../../Context/colorContext'
import theme from '../../../../services/theme-service'

export default function SkeltonChannelAttendante(): JSX.Element {
  const [isAuth, setIsAuth] = useState<boolean>(true)
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '40px 5px',
    },
    card: {
      borderRadius: 10,
      textTransform: 'capitalize',
      width: '100%',
      color: colors.accentColor,
      fontSize: theme.typography.pxToRem(24),
      background: colors.colorGradient,
      '&:hover': {
        backgroundColor: colors.colorBackground,
      },
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 700,
      color: colors.textBody,
      left: 8,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        width: '85%',
        marginBottom: 19,
        '&::after': {
          bottom: 4,
        },
      },
    },
    textSubTitle: {
      position: 'relative',
      fontFamily: 'Roboto',
      paddingBottom: 40,
      color: colors.textBody,
      letterSpacing: '0.1px',
      lineHeight: '24px',
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(18),
      opacity: 0.5,
    },
    icon: {
      width: 24,
      height: 24,
    },
    carrousel: {
      '& .slick-list': {
        margin: 0,
      },
    },
    boxChannels: {
      display: 'flex',
      justifyContent: 'center',
      gap: '13px 16px',
      [theme.breakpoints.down('md')]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      },
    },
    box: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
      },
    },
  }))
  const classes = useStyles()

  const menuNameAtendimento =
    process.env.REACT_APP_NAME_ATENDIMENTO ?? 'OUTROS CANAIS DE ATENDIMENTO'
  const menuDescriptionAtendimento =
    process.env.REACT_APP_DESCRIPTION_ATENDIMENTO ??
    'Registre aqui sua manifestação'

  return (
    <Box className={classes.main}>
      <ModalNotAuth open={!isAuth} onClose={(): void => setIsAuth(true)} />
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            {menuNameAtendimento}
          </Typography>
          <Typography className={classes.textSubTitle}>
            {menuDescriptionAtendimento}
          </Typography>
        </Box>
        <Box className={classes.boxChannels}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} className={classes.card} height={220} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
